import { Environment } from "@/types/app/environment";
import { Tag } from "./Tag";
import { LabelDot } from "./Entities/EntityIcon";

interface OwnProps {
  environment: Pick<Environment, "name" | "tag">;
}

type Props = OwnProps & Pick<React.ComponentProps<typeof Tag>, "size">;

export const EnvironmentTag = ({ environment, ...props }: Props) => {
  const isDefault = environment.tag === "default";
  return (
    <>
      <Tag color={isDefault ? "green" : "gray"} {...props} className="w-min">
        <div className="flex items-center gap-4">
          {environment.name}
          {isDefault && <LabelDot type={"production"} />}
        </div>
      </Tag>
    </>
  );
};
